/*istanbul ignore next*/'use strict';

module.exports = {
  View: require('./view')
};


// WEBPACK FOOTER //
// ./~/_mokit@3.1.3@mokit/lib/component/components/index.js